import styled from 'styled-components';
export const BodyColContainer = styled.td`
  padding: 0 12px;
  height: 8px;
  color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.neutralL5;
}};
  min-width: ${_ref2 => {
  let {
    minWidth
  } = _ref2;
  return minWidth ?? 'auto';
}};
  max-width: ${_ref3 => {
  let {
    maxWidth
  } = _ref3;
  return maxWidth ?? '100%';
}};
`;
export const BodyCellWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${_ref4 => {
  let {
    align
  } = _ref4;
  return align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'center';
}};
  justify-content: center;
`;
export const ContentText = styled.span`
  display: block;
  ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.fonts.infoMD;
}};
`;
export const Description = styled.span`
  display: block;
  ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.fonts.infoXS;
}};
`;
export const ContentElement = styled.div`
  max-height: 20px;
  max-width: 20px;
`;